"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const RESOURCE_ROLE = 'user/table/entry/role';
class RoleService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        /**
         * Get by ID
         * @param id
         * @returns
         */
        this.getById = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${RESOURCE_ROLE}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Update Role
         * @param body
         * @returns
         */
        this.update = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${RESOURCE_ROLE}`;
            const response = await axios_1.default.put(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Save Role
         * @param body
         * @returns
         */
        this.save = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${RESOURCE_ROLE}`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        // GET ALL
        /**
         * Retrieves all **roles** with specified filters
         * @param page **Type** `number` Page number **value default:** 1
         * @param size **Type:** `number` Page size **value default:** 10
         * @param filters **Type:** `object` Others filter **example:**  filters= [{name:'Test'}, {description:'Test'}] or filters = [{name:'Test'}]
         * @returns **Type:** `object` **example:** {data:[],
                                                    "currentPage": 1,
                                                    "pageSize": 2,
                                                    "totalCount": 2,
                                                    "totalPages": 1}
         */
        this.getAll = async (page, filters, size = 10) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/roles?page=${page}&size=${size}`;
            for (let items of filters) {
                let filter = items;
                for (const key in filter) {
                    let keyFilter = key;
                    URL += `&${key}=${filter[keyFilter]}`;
                }
            }
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.RoleService = RoleService;
